import React, { useState, useEffect } from "react";
import { components } from 'react-select';
// components
import Select from "../Select";
import Text from 'components/Text';
import { Row } from "components/Layout/Grid";
import { Visibility } from "components/Visibility";
import Input from "pages/Quotes/components/generics/Input/Input";
import { TooltipIcon } from "pages/Quotes/components/TooltipIcon";
//interface
import { PaymentTermDropdownProps } from "../interface";
//assets
import arrowIcon from 'img/arrow-down-grey.svg';
import warningIcon from "img/round-warning-icon.svg";
//utils
import { onlyNumbers } from "pages/Quotes/utils/patterns";
import { currencyOutputNumber } from "utils/CurrencyOutput";
//styles
import { PaymentDeadline, PaymentTermDropdownContainer } from "./styles";
import "../style.css";

const PaymentTermDropdown = (props: PaymentTermDropdownProps) => {
  const {
    dcName,
    deadline,
    setDeadline,
    defaultValue,
    paymentMethods,
    paymentListError,
    paymentTermError,
    paymentMethodList,
    quoteNotDownloaded,
    setPaymentListError,
    shouldCleanSelected,
    listDistributionCenters,
    handleSelectedPaymentTerm,
  } = props;

  const [optionValue, setOptionValue] = useState<any>();

  const minimumBilling = listDistributionCenters?.totalDistributionCenter < listDistributionCenters?.minimumPurchase;
  const minimumBillingCondition = minimumBilling ? `Faturamento mínimo para ${dcName}: ${currencyOutputNumber(listDistributionCenters?.minimumPurchase)}` : '';

  useEffect(() => {
    if (shouldCleanSelected) {
      setOptionValue(null);
    }
  }, [shouldCleanSelected]);

  useEffect(() => {
    if (defaultValue) {
      setOptionValue(defaultValue);
    }
  }, [defaultValue]);

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={arrowIcon} alt="" />
      </components.DropdownIndicator>
    );
  };

  const customStyles = {
    singleValue: (provided: any, state: any) => ({
      ...provided,
      fontSize: 11,
      color: '#364863'
    }),
  };

  useEffect(() => {
    const paymentMethodSelectedDc = paymentMethods?.find(payment => payment.distributionCenter === dcName);

    if (paymentMethodSelectedDc && paymentMethodList.length > 0) {
      const paymentDefault = paymentMethodList.find(paymentList =>
        paymentList.protheusName === paymentMethodSelectedDc.paymentMethod);

      setOptionValue(paymentDefault);
      handleSelectedPaymentTerm(dcName, paymentDefault);
    }
  }, [paymentMethodList]);

  const changePaymentTerm = (payment: string) => {
    const newPaymentTerm = {
      dcName: dcName, paymentTerm: payment
    };

    const index = deadline.findIndex(x => x.dcName === dcName);

    if (index !== -1)
      deadline.splice(index, 1, newPaymentTerm);
    else
      deadline.push(newPaymentTerm);

    setDeadline(deadline);

    if (payment.length > 0)
      setPaymentListError(paymentListError.filter(pay => pay !== dcName));
    else
      setPaymentListError([...paymentListError, dcName]);
  };

  const valueDeadline = deadline.find(x => x.dcName === dcName)?.paymentTerm;
  const checkValueValid = !paymentListError.includes(dcName) && (Number(valueDeadline) > 0 && Number(valueDeadline) < 99);

  return (
    <PaymentTermDropdownContainer minimumBilling={minimumBilling} quoteNotDownloaded={quoteNotDownloaded}>
      <Row className="dropDownContent">
        <div className="cdName">
          <strong>{dcName}</strong>
          <Visibility visible={quoteNotDownloaded && !document.body.textContent?.includes('MVM')}><span>*</span></Visibility>
        </div>

        <div>
          <Select
            styles={customStyles}
            className="#coupon-brand-select payment-term-select"
            value={optionValue}
            components={{ DropdownIndicator }}
            options={paymentMethodList}
            placeholder={"Escolha um prazo*"}
            getOptionLabel={(option: any) => option.protheusName}
            getOptionValue={(option: any) => option}
            onChange={(option: any) => {
              setOptionValue(option);
              handleSelectedPaymentTerm(dcName, option);
            }}
            theme={(theme: any) => ({
              ...theme,
              borderRadius: '5px',
              colors: {
                ...theme.colors,
                primary25: 'none',
                primary: 'none',
              },
            })}
          />

          {paymentTermError.includes(dcName) && !optionValue &&
            <Row>
              <PaymentDeadline>A escolha do prazo é obrigatória</PaymentDeadline>
            </Row>
          }
        </div>

        <div className="dateInputArea">
          <Input
            width="46px"
            type="number"
            pattern={onlyNumbers}
            value={valueDeadline}
            setIsValid={() => { }}
            isValid={checkValueValid}
            isPayment={checkValueValid}
            onChange={(number: string) => changePaymentTerm(number)} />
          <Text>{Number(valueDeadline) === 1 ? "dia útil" : "dias úteis"}</Text>
        </div>

        <div className="minimumBilling" data-for={"minimumBilling"} data-tip={minimumBillingCondition} data-type={"light"}>
          <Visibility visible={minimumBilling}>
            <TooltipIcon 
              alt="ícone de alerta para faturamento mínimo"
              icon={warningIcon}
              tooltip={minimumBillingCondition}
              size={12.8}
            />
          </Visibility>
          <Text>{currencyOutputNumber(listDistributionCenters?.totalDistributionCenter)}</Text>
        </div>
      </Row>
    </PaymentTermDropdownContainer>
  );
};

export default PaymentTermDropdown;